// Centralized app-wide constants

export const membersRoute = '/members';
